import React from 'react';
import { FaBars, FaSearch } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { navOpened } from '../../redux/navigation/navigation';
import navLinks from '../../utils/navLinks';
import './header.scss';

const Header = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(navOpened());
  };

  return (
    <header className="header_container w-full">
      <div className="header-scrolled text-2xl flex justify-between items-center lg:border-y-[0.0px] border-current">
        <button type="button" onClick={handleClick} className="hamburger-lines">
          <FaBars />
        </button>
        <h2 className="logo uppercase tracking-tighter font-bold h-full flex flex-col justify-center items-center">
          <NavLink to="/" className="logo text-secondary transition-colors">
            COMIGRA
          </NavLink>
        </h2>
        <nav className="navbar hidden justify-center items-center h-[70px] border-current">
          <ul className="nav_menu w-2/4 mt-[0px] flex justify-between items-center">
            {navLinks.map((link) => (
              <li key={link.name} className="menu_item flex justify-between items-center flex-col hover:text-accent transition-colors">
                <NavLink to={link.link} activeClassName="active">
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <button
          type="button"
          className="search text-primary lg:border-x-[0.5px] lg:px-5 lg:h-[65px] border-current"
        >
          <FaSearch />
        </button>
      </div>
    </header>
  );
};

export default Header;
